export default "__VITE_ASSET__173V5LXU__"